import { render, staticRenderFns } from "./my-audio.vue?vue&type=template&id=d2caa63a&scoped=true&"
import script from "./my-audio.vue?vue&type=script&lang=js&"
export * from "./my-audio.vue?vue&type=script&lang=js&"
import style0 from "./my-audio.scss?vue&type=style&index=0&id=d2caa63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2caa63a",
  null
  
)

export default component.exports